module.exports = __webpack_public_path__ + "static/car1-d7d81a4ee2366c6a4f5b283f7732396b.png";